import { render, staticRenderFns } from "./SelectWares.vue?vue&type=template&id=733e8131&scoped=true&"
import script from "./SelectWares.vue?vue&type=script&lang=js&"
export * from "./SelectWares.vue?vue&type=script&lang=js&"
import style0 from "./SelectWares.vue?vue&type=style&index=0&id=733e8131&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e8131",
  null
  
)

export default component.exports